// extracted by mini-css-extract-plugin
module.exports = {"div1":"SignIn_div1__IB7dt","div2":"SignIn_div2__DIxqI","signin":"SignIn_signin__RT93r","use":"SignIn_use__2A8iY"};